module.exports = __webpack_public_path__ + "static/media/S1_00038.a93d40d0.jpg";